var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00008 2.00008C7.46965 2.00008 6.96094 2.2108 6.58587 2.58587C6.21079 2.96094 6.00008 3.46965 6.00008 4.00008V6.66675H11.3334C12.438 6.66675 13.3334 7.56218 13.3334 8.66675V12.6667C13.3334 13.7713 12.438 14.6667 11.3334 14.6667H4.66675C3.56218 14.6667 2.66675 13.7713 2.66675 12.6667V8.66675C2.66675 7.56218 3.56218 6.66675 4.66675 6.66675V4.00008C4.66675 3.11603 5.01794 2.26818 5.64306 1.64306C6.26818 1.01794 7.11603 0.666748 8.00008 0.666748C8.88414 0.666748 9.73198 1.01794 10.3571 1.64306C10.9822 2.26818 11.3334 3.11603 11.3334 4.00008C11.3334 4.36827 11.0349 4.66675 10.6667 4.66675C10.2986 4.66675 10.0001 4.36827 10.0001 4.00008C10.0001 3.46965 9.78937 2.96094 9.41429 2.58587C9.03922 2.2108 8.53051 2.00008 8.00008 2.00008ZM4.66675 8.00008C4.29856 8.00008 4.00008 8.29856 4.00008 8.66675V12.6667C4.00008 13.0349 4.29856 13.3334 4.66675 13.3334H11.3334C11.7016 13.3334 12.0001 13.0349 12.0001 12.6667V8.66675C12.0001 8.29856 11.7016 8.00008 11.3334 8.00008H4.66675ZM6.66675 10.6667C6.66675 9.93037 7.2637 9.33342 8.00008 9.33342C8.73646 9.33342 9.33341 9.93037 9.33341 10.6667C9.33341 11.4031 8.73646 12.0001 8.00008 12.0001C7.2637 12.0001 6.66675 11.4031 6.66675 10.6667Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.a490c2345b516ab85e4849823dca6405.svg";
export { ForwardRef as ReactComponent };